import {rcp_refresh_interval, rcp_hp_fetching_data, rcp_hp_fetch_callbacks, E2020_PUB_PATH} from './ElectionCommonVars.js';

export default {
    data() {
        return {
            rcp_refresh_interval: rcp_refresh_interval,
            rcp_hp_fetching_data: rcp_hp_fetching_data,
            rcp_hp_fetch_callbacks: rcp_hp_fetch_callbacks,
            rcp_hp_fetch_callbacks: rcp_hp_fetch_callbacks,
            E2020_PUB_PATH: E2020_PUB_PATH,
        };
    },
    methods: {

        rcp_cache_bust: function() {
            // Returns a unique value that is different every 10 sec
            return Math.round(new Date().getTime() / 10000);
        },

        rcp_hp_fetch_data: function(callback) {

            this.rcp_hp_fetch_callbacks.push(callback);
          
            if(!this.rcp_hp_fetching_data) {
          
                this.rcp_hp_fetching_data = true;
                //axios.get('/elections/live_results/2018/homepage.json?cache_bust='+rcp_cache_bust())
                axios.get(E2020_PUB_PATH+'/homepage.json?cache_bust='+this.rcp_cache_bust())
                .then((response) => {
          
                    for(var i = (this.rcp_hp_fetch_callbacks.length - 1); i >= 0; i--) {
                        this.rcp_hp_fetch_callbacks[i](response);
                    }

                    this.rcp_hp_fetch_callbacks = [];
                    this.rcp_hp_fetching_data = false;
                });
          
                // axios.get('/json/ap_results/2016_general/data_president.json?cache_bust='+rcp_cache_bust())
                // .then(function(response) {
            
                //   // for(var i = 0; i < rcp_hp_fetch_callbacks.length; i++) {
                //   //   rcp_hp_fetch_callbacks[i](response);
                //   // }
                //   // rcp_hp_fetch_callbacks = [];
                //   // this.rcp_hp_fetching_data = false;
                // });
            }
        },

        capitalize_string : function(str) {
            return str.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
        },
      
        electoral_votes_for_state : function(region_key) {
      
            var states = {
                'AK' : 3,
                'AL' : 9,
                'AR' : 6,
                'AZ' : 11,
                'CA' : 55,
                'CO' : 9,
                'CT' : 7,
                'DC' : 3,
                'DE' : 3,
                'FL' : 29,
                'GA' : 16,
                'HI' : 4,
                'IA' : 6,
                'ID' : 4,
                'IL' : 20,
                'IN' : 11,
                'KS' : 6,
                'KY' : 8,
                'LA' : 8,
                'MA' : 11,
                'MD' : 10,
                'ME' : 4,
                'MI' : 16,
                'MN' : 10,
                'MO' : 10,
                'MS' : 6,
                'MT' : 3,
                'NC' : 15,
                'ND' : 3,
                'NE' : 5,
                'NH' : 4,
                'NJ' : 14,
                'NM' : 5,
                'NV' : 6,
                'NY' : 29,
                'OH' : 18,
                'OK' : 7,
                'OR' : 7,
                'PA' : 20,
                'RI' : 4,
                'SC' : 9,
                'SD' : 3,
                'TN' : 11,
                'TX' : 38,
                'UT' : 6,
                'VA' : 13,
                'VT' : 3,
                'WA' : 12,
                'WI' : 10,
                'WV' : 5,
                'WY' : 3,
            };
      
            if(typeof states[region_key] === 'undefined') {
                return 0;
            } else {
                return states[region_key];
            }
        },
      
        races_with_vote_totals : function(races) {
      
          // Requires 'races' object be fully populated with data
      
          for(var i = 0; i < races.length; i++) {
      
            var vote_total = 0;
      
            for(var j = 0; j < races[i].reportingUnit.candidates.length; j++) {
      
              var c = races[i].reportingUnit.candidates[j];
      
              vote_total += parseInt(c.voteCount);
            }
      
            races[i]['voteTotal'] = vote_total;
          }
      
          return races;
        },
      
        electoral_display : function(postal) {
      
          var val = this.electoral_votes_for_state(postal.toUpperCase());
      
          if(postal.toUpperCase() == 'ME') {
            val = '3*';
          } else if(postal.toUpperCase() == 'NE') {
            val = '4*';
          }
      
          return val;
        },
      
        state_name_display : function(state_name, seat_name, election_type) {
      
          var final_name = state_name + (seat_name != null ? ' '+this.seat_display(seat_name) : '');
      
          if(election_type == 'senate') {
            if(final_name == 'Arizona Special') {
              return 'Arizona';
            }
          }
      
          if(election_type == 'president') {
            if(final_name == "District of Columbia") {
              return 'D.C.';
            }
          }
      
          return final_name;
        },
      
        net_display : function(num) {
      
          if(num > 0) {
            return '(+'+num+')';
          } else if(num < 0) {
            return '('+num+')';
          } else {
            return '';
          }
        },
      
        has_winner : function(race) {
      
          var winner = this.find_winner(race);
      
          if( typeof winner.party !== 'undefined' ) {
            return true;
          }
      
          return false;
        },
      
        winner_party : function(race) {
      
          var winner = this.find_winner(race);
      
          if( typeof winner.party !== 'undefined' ) {
            return winner.party.toLowerCase();
          }
      
          return '';
        },
      
        winner_is_pickup : function(race) {
      
          var winner = this.find_winner(race);
      
          if( typeof winner.party !== 'undefined' ) {
      
            if(race.holding_party != this.party_name_to_basename(winner.party)) {
              return true;
            }
          }
      
          return false;
        },
      
        winner_hold_pickup_text : function(race) {
      
          var winner = this.find_winner(race);
          var text = '';
      
          if( typeof winner.party !== 'undefined' ) {
      
            var winner_party = winner.party;
      
            if(winner['first'] == 'Bernie' && winner['last'] == 'Sanders') {
              winner_party = 'Dem';
            }
      
            text += winner_party + ' ';
      
            if(race.holding_party != this.party_name_to_basename(winner.party)) {
              text += 'Pickup';
            } else {
              text += 'Hold';
            }
          }
        
          var is_runoff = this.find_runoff(race);
          if(Object.keys(is_runoff).length > 0){
            text = 'Runoff';
          }
      
          // Temporarily hide runoff for GA Senate (non-special) 2020
          /*if(race['raceID'] == "12301") {
            text = '';
          }*/
      
          // Called LA5 for top candidates so it would flow into GOP numbers,
          // but still displayin as runoff using this logic
          if(race['raceID'] == "20052") {
            text = 'GOP Hold/Runoff';
          }
      
          text = text.replace("Dem", "<span class='full'>Dem</span><span class='short'>D</span>");
          text = text.replace("GOP", "<span class='full'>GOP</span><span class='short'>R</span>");
      
          return text;
        },
      
        vote_perc_display : function(num, total) {
      
          if(total > 0) {
            return (Math.round((parseInt(num) / parseInt(total)) * 1000) / 10).toFixed(1);
          } else {
            return "0.0";
          }
        },
      
        party_name_to_basename : function(bn) {
      
          if(bn == 'GOP') {
            return 'gop';
          } else if(bn == 'Dem') {
            return 'dem';
          } else {
            return bn.toLowerCase().replace(/ /g,"_");
          }
        },
      
        party_basename_to_name : function(bn) {
      
          if(bn == 'gop') {
            return 'GOP';
          } else if(bn == 'dem') {
            return 'Dem';
          } else {
            return bn.charAt(0).toUpperCase() + bn.slice(1); // Capitalize
          }
        },
      
        find_winner : function(race) {
      
          for(var i = 0; i < race.reportingUnit.candidates.length; i++) {
      
            var c = race.reportingUnit.candidates[i];
      
            if(c.winner_override != null && c.winner_override.toLowerCase() == 'x') {
              return c;
            }
          }
      
          for(var i = 0; i < race.reportingUnit.candidates.length; i++) {
      
            var c = race.reportingUnit.candidates[i];
      
            if(c.winner != null && c.winner.toLowerCase() == 'x') {
              return c;
            }
          }
      
          return {};
        },
      
        find_runoff : function(race) {
          
          for(var i = 0; i < race.reportingUnit.candidates.length; i++) {
      
            var c = race.reportingUnit.candidates[i];
      
            if(c.winner_override != null ) {
              if(c.winner_override.toLowerCase() == 'r'){
                return c;
              }
            }
          }
      
          for(var i = 0; i < race.reportingUnit.candidates.length; i++) {
      
            var c = race.reportingUnit.candidates[i];
      
            if(c.winner != null) {
              if(c.winner.toLowerCase() == 'r'){
                return c;
              } 
            }
          }
      
          return {};
        },
      
        candidates_with_party : function(candidates, party, limit) {
      
          // NOTE: Right now a limit of anything over 0 does the same thing:
          // returns highest voted candidate for that party
      
          var cwp = this.find_objects(candidates, 'party', party);
          
          // Find one matching candidate with most votes
          var top_index = 0;
          var top_votes = 0;
          var return_candidates = [];
      
          if(cwp.length > 0 && limit > 0) {
      
            for(var i = 0; i < cwp.length; i++) {
      
              if(parseInt(cwp[i].voteCount) > top_votes) {
                top_votes = cwp[i].voteCount;
                top_index = i;
              }
      
              // GA Special override of what candidates show in Dem and GOP fields
      
              if(cwp[i]['ru_id'] == "2057" && party == 'GOP' && cwp[i]['last'] == "Loeffler") {
                top_index = i;
                break;
              }
              if(cwp[i]['ru_id'] == "2057" && party == 'Dem' && cwp[i]['last'] == "Warnock") {
                top_index = i;
                break;
              }
            }
            return_candidates.push(cwp[top_index]);
          }
          return return_candidates;
        },
      
        column_candidates : function(candidates, col_num) {
      
          if(candidates[0]['ru_id'] == "2057") {
      
            // GA Special override of what candidates show in "other" columns
      
            var return_candidates = [];
      
            for(var i = 0; i < candidates.length; i++) {
      
              if(candidates[i]['last'] == 'Collins') {
                return_candidates.push(candidates[i]);
              }
            }
      
            return return_candidates;
      
          } else {
      
            // Default behavior
      
            return this.find_objects(candidates, 'show_in_column', col_num, 1);
          }
          
        },
      
        any_column_candidates : function(races, col_num) {
      
          for(var i = 0; i < races.length; i++) {
      
            var candidates = races[i]['reportingUnit']['candidates'];
      
            // If any races are GA special, return true because we are showing a third candidate
            if(candidates[0]['ru_id'] == "2057") {
              return true;
            }
      
            // Default behavor, find if any candidates marked as "show_in_column"
            for(var j = 0; j < candidates.length; j++) {
              if(candidates[j]['show_in_column'] == col_num) {
                return true;
              }
            }
          }
      
          return false;
        },
      
        find_objects : function(arr_of_objs, key, val, limit) {
      
          var objects = [];
      
          var count = 0;
      
          if(typeof limit === 'undefined') {
            limit = 9999999999999999999999;
          }
      
          for(var i = 0; i < arr_of_objs.length; i++) {
      
            if( typeof arr_of_objs[i][key] === 'undefined' ) {
              continue;
            }
      
            if( arr_of_objs[i][key] == val ) {
      
              objects.push(arr_of_objs[i]);
              count++;
              if(count >= limit) {
                break;
              }
            }
          }
      
          return objects;
        },
      
        seat_display : function(seat_str) {
      
          if(seat_str == 'Unexpired Term') {
            return 'Special';
          }
      
          return seat_str.replace('District', '<span class="district_label">District</span>');
        },
      
        party_display : function(c) {
      
          if( (c['first'] == 'Bernie' && c['last'] == 'Sanders') || (c['first'] == 'Angus' && c['last'] == 'King') ) {
            return 'Dem';
          }
      
          return c['party'];
        },
      
        race_detail_link : function(race, page_basename) {
      
          if(race.seatName == 'Unexpired Term' && race.statePostal == 'GA') {
            //return '';
            return E2020_PUB_PATH+'/state/'+race.reportingUnit.statePostal.toLowerCase()+'/'+this.featured_race_type_to_race_type(page_basename)+'/'+race.reportingUnit.statePostal.toLowerCase()+'_special.html';
          } else { 
            return E2020_PUB_PATH+'/state/'+race.reportingUnit.statePostal.toLowerCase()+'/'+this.featured_race_type_to_race_type(page_basename)+'/';
          }
        },
      
        featured_race_type_to_race_type : function(str) {
      
          var type_matchup = {
            "senate" : "senate",
            "governor" : "governor",
            "house" : "house",
            "house_top_50" : "house",
            "house_northeast" : "house",
            "house_midwest" : "house",
            "house_south" : "house",
            "house_west" : "house",
            "house_alt" : "house",
            "president" : "president", //DN
          };
      
          return type_matchup[str];
        },
      
        display_precincts_perc : function(race) {
      
          /*if(race.officeName == 'U.S. Senate' && race.stateName == 'Arizona') {
            return '(---%)';
          }*/
      
          //return '('+Math.round(Number(race.reportingUnit.precinctsReportingPct))+'%)';
          return '('+Math.round(Number(race.reportingUnit.precinctsReportingPct_rcp))+'%)';
        },
      
        get_candidate_data1 : function(last_name, get_value, cand){
      
          var cand = this.president_summary.candidates;
          if(typeof cand !== 'undefined' && cand.length > 0){
            for(i=0; i < cand.length; i++){
              var c = cand[i];
              if(c.last == last_name){
                
                var val = c[get_value];
                //=START = Just incase we need to override electoral count total
                // if(get_value == 'electWon' && last_name == 'Trump'){
                //   val = parseInt(val) + 16;
                // }
                // if(get_value == 'electWon' && last_name == 'Biden'){
                //   val = parseInt(val) + 16;
                // }
                //=END = 
                return val;
              }
            }
          }
          
        },
    },
};